import { render, staticRenderFns } from "./ConfiguracionMapeos.vue?vue&type=template&id=256280aa&scoped=true&"
import script from "./ConfiguracionMapeos.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionMapeos.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionMapeos.vue?vue&type=style&index=0&id=256280aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256280aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('256280aa', component.options)
    } else {
      api.reload('256280aa', component.options)
    }
    module.hot.accept("./ConfiguracionMapeos.vue?vue&type=template&id=256280aa&scoped=true&", function () {
      api.rerender('256280aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/Step/ConfiguracionMapeos.vue"
export default component.exports